<template>
  <div class="main-wrapper">
    <layout-header class="no-print"></layout-header>
    <layout-sidebar class="no-print"></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row print">
          <div class="col-md-12">
            <div class="row receipt-wrapper" style="margin-top: 16px;">
              <div class="col-lg-9 mb-5" v-if="retrievedReceipt && retrievedReceipt.id" ref="receiptContainer">
                <div class="card" hidden>
                  <div class="card-header">
                    <h4 class="card-title d-flex justify-content-between"><span>{{ retrievedReceipt.number }}</span>
                      <div><a class="btn btn-sm bg-danger text-white"><i class="fa fa-trash"></i> Delete</a></div>
                    </h4>
                  </div>
                </div>
                <div class="card printBoarder" id="printMe" ref="printMe">
                  <div class="card-header pb-4" v-if="!pos">
                    <div class="row mt-3 pt-3">
                      <div class="col-md-6 col-sm-12" v-if="receipt.sender">
                        <div v-if="logoUrl" class="mb-4">
                          <img class="preview img-fluid" :src="logoUrl" alt="" style="max-width: 180px;"/>
                        </div>
                        <div>
                          <span style="font-weight: bold">{{
                              receipt.sender.company && receipt.sender.company.toUpperCase()
                            }}</span>
                        </div>
                        <div>
                          <span class="pre-line">{{ receipt.sender.address }}</span>
                        </div>
                        <div>
                          <span>{{ receipt.sender.email }}</span>
                        </div>
                        <div>
                          <span>{{ receipt.sender.phone }}</span>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 pull-left quote-header">
                        <div class="row">
                          <div class="col-md-12 col-sm-6">
                            <h2 id="docName" v-if="isExporting" class="text-right mr-3"
                                style="font-family: 'Gill Sans',serif; font-weight: bolder"> {{
                                receipt.labels.name
                              }}</h2>
                            <h2 v-if="!isExporting" class="text-left mr-5 w101">
                              <label readonly="readonly" type="text"
                                     class="input text-right w99"
                                     style="font-family: 'Gill Sans',serif; font-weight: bolder">{{
                                  receipt.labels.name
                                }}</label>
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3 mb-0">
                      <div class="col-md-4 col-sm-12 mt-3">
                        <table class="tblReceiptHeaderDetails table table-hover table-center mb-0 datatable"
                               v-if="retrievedReceipt.customerId">
                          <tbody>
                          <tr class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold">
                            <td class="text-left">To:</td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left" v-if="customer">
                              <a :href="'/customers/' + customer.id" class="text-decoration-none text-dark">
                                {{ customer.fullName || customer.fullName }}
                              </a>
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left" v-if="customer.address === null && customer.email">{{
                                customer.email
                              }}
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left" v-if="customer.address === null && customer.phone">{{
                                customer.phone
                              }}
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"><span class="pre-line">{{ customer.address }}</span></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-4 col-sm-12 mt-3">
                        <table class="tblReceiptHeaderDetails table table-hover table-center mb-0 datatable"
                               v-if="customer && receipt.shippingAddress">
                          <tbody>
                          <tr class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold">
                            <td class="text-left">Ship To:</td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left" v-if="customer.address === null && customer.email">{{
                                customer.email
                              }}
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left" v-if="customer.address === null && customer.phone">{{
                                customer.phone
                              }}
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"><span class="pre-line">{{ customer.address }}</span></td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-4 col-sm-12 mt-3">
                        <table class="tblReceiptHeaderDetails table table-hover table-center mb-0 datatable ">
                          <tbody>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left" style="font-weight: bold">Receipt:</td>
                            <td class="text-right">{{ retrievedReceipt.number }}</td>
                          </tr>
                          <tr hidden v-if="retrievedReceipt.currency" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Currency:</td>
                            <td class="text-right">{{ retrievedReceipt.currency }}</td>
                          </tr>
                          <tr v-if="retrievedReceipt.dateCreated" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Date:</td>
                            <td class="text-right">{{ getDate(retrievedReceipt.date) }}</td>
                          </tr>
                          <tr v-if="retrievedReceipt.paymentMethod" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Method:</td>
                            <td class="text-right">
                              {{ retrievedReceipt.paymentMethod ? retrievedReceipt.paymentMethod.description : '-' }}
                            </td>
                          </tr>
                          <tr v-if="retrievedReceipt.dueDate" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Due Date:</td>
                            <td class="text-right">{{ getDate(retrievedReceipt.dueDate) }}</td>
                          </tr>
                          <tr v-if="retrievedReceipt.projectName" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Project:</td>
                            <td class="text-right">{{ retrievedReceipt.projectName }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-2">
                    <div class="table">
                      <div>
                        <table id="tblItems" class="tblItems table table-hover table-center mb-0 datatable">
                          <thead style="background-color: #666; color: white" id="items-header">
                          <tr class="text-center">
                            <th class="text-left col-md-6">Description</th>
                            <th class="text text-center" hidden>Qty</th>
                            <th class="text text-center" hidden>Price</th>
                            <th class="text text-right">Amount</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr style="background-color: white" class="text-center"
                              v-for="receiptLine in retrievedReceipt.items" :key="receiptLine.itemCode">
                            <td class="text-left col-md-6" style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{ receiptLine.itemName }}
                              </span>
                            </td>
                            <td style="padding-top: 0.35rem; padding-bottom: 0.35rem" hidden>
                              <span>
                                {{ receiptLine.quantity }}
                              </span>
                            </td>
                            <td style="padding-top: 0.35rem; padding-bottom: 0.35rem" hidden>
                              <span>
                                {{
                                  retrievedReceipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
                                    style: 'currency',
                                    currency: retrievedReceipt.transactionCurrency
                                  }).format(retrievedReceipt.amountPaid / 100) : '-'
                                }}
                              </span>
                            </td>
                            <td class="text text-right" style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{
                                  retrievedReceipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
                                    style: 'currency',
                                    currency: retrievedReceipt.transactionCurrency
                                  }).format(receiptLine.quantity * retrievedReceipt.amountPaid / 100) : '-'
                                }}
                              </span>
                            </td>
                          </tr>
                          </tbody>
                        </table>

                        <hr style="margin-bottom: 0.3em; margin-top: 0.3em"/>

                        <div class="row mb-0">
                          <div class="col-md-4 col-sm-12"></div>
                          <div class="col-md-4 col-sm-12"></div>
                          <div class="col-md-4 col-sm-12">
                            <table class="tblPayments table table-hover table-center mb-0 datatable">
                              <tbody>
                              <tr hidden class="text-right borderless"
                                  style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);"
                                  v-if="retrievedReceipt.amountPaidCurrency !== retrievedReceipt.currency">
                                <td class="text-left">Paid:</td>
                                <td class="text-right">{{
                                    retrievedReceipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedReceipt.transactionCurrency
                                    }).format(retrievedReceipt.amountPaid / 100) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                                <td class="text-left">Tendered</td>
                                <td class="text-right">{{
                                    retrievedReceipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedReceipt.transactionCurrency
                                    }).format(retrievedReceipt.amountTendered / 100) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                                <td class="text-left">Paid</td>
                                <td class="text-right">{{
                                    retrievedReceipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedReceipt.transactionCurrency
                                    }).format(retrievedReceipt.amountPaid / 100) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                                <td class="text-left">Refunded</td>
                                <td class="text-right">{{
                                    retrievedReceipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedReceipt.transactionCurrency
                                    }).format(retrievedReceipt.refundedAmount / 100) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);"
                                  hidden>
                                <td class="text-left">Rate</td>
                                <td class="text-right">
                                  {{ retrievedReceipt.rate ? (retrievedReceipt.rate / 100).toFixed(2) : '-' }}
                                </td>
                              </tr>
                              <tr v-if="retrievedReceipt.type === 'POS'" class="text-right borderless"
                                  style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold; background-color: #f5f5f5">
                                <td class="text-left">Change:</td>
                                <td class="text-right">{{
                                    retrievedReceipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedReceipt.transactionCurrency
                                    }).format((retrievedReceipt.amountTendered - retrievedReceipt.amountPaid) / 100) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr hidden v-else class="text-right borderless"
                                  style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold; background-color: #f5f5f5">
                                <td class="text-left">Remaining:</td>
                                <td class="text-right">{{
                                    retrievedReceipt.transactionCurrency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedReceipt.transactionCurrency
                                    }).format(retrievedReceipt.amountRemaining / 100) : '-'
                                  }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="retrievedReceipt.notes" class="row mt-0" id="termsAndConditions">
                      <div class="col-12">
                        <label class="form-label me-1"></label>
                        <span class="show-footer-label-modal text-decoration-dotted form-label">
                          <label readonly="readonly" class="w101 bold" type="text"
                                 style="height: 35px; font-weight: bold; margin-bottom: 0px;">Notes:</label>
                        </span>
                        <span class="white-space pre-line">
                          {{ retrievedReceipt.notes }}
                        </span>
                      </div>
                    </div>
                    <div v-if="!isExporting"
                         style="overflow-y: auto; min-height: calc(100vh - 500px) !important;"></div>
                  </div>
                  <div hidden class="card-footer">
                  </div>
                </div>
              </div>
              <div class="col-lg-9 mb-5" v-else-if="isLoading && !retrievedReceipt.id">
                <DocumentSkeleton :rows="10" :columns="6"/>
              </div>
              <div class="col-lg-3 no-print">
                <div class="card">
                  <div class="card-body">
                    <div v-if="retrievedReceipt">
                      <div class="text-center">
                        <button @click="downloadAsPdf"
                                :disabled="isLoading"
                                class="btn btn-block text-white" style="background-color: black">
                          <span v-if="!isLoading">
                            <i class="fas fa-download"></i> Download As PDF
                          </span>
                          <span v-else>
                            <i class="fas fa-spinner fa-spin"></i> Downloading...
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js/src";

import storeService from "../../service/store.service";
import receiptService from "../../service/receipt.service";
import currencyService from "../../service/currency.service";
import fileService from "../../service/file.service";
import {base64StringToBlob} from "blob-util";
import moment from "moment";
import jwtDecode from "jwt-decode";
import paymentMethodService from "../../service/payment.method.service";
import customerService from "../../service/customer.service";
import DatePicker from "vue2-datepicker";
import process from "shelljs";
import {getConfig} from "../../utils/config";
import invoiceService from "../../service/invoice.service";
import {errorCodes} from "../../interceptors/codes";
import {getCurrencySymbol, toFilename} from "../../utils/utils";
// import printingService from "../../service/printing.service"; // Customer portal doesn't need POS printing
import {handleError, showSuccessToast} from "../../utils/notification.utils";
import {downloadReceiptPdf} from "../../utils/invoiceUtils";
import DocumentSkeleton from "../shared/DocumentSkeleton";

export default {
  name: "ViewReceipt",
  components: {
    DatePicker,
    DocumentSkeleton
  },
  data() {
    return {
      store: null,
      receiptId: null,
      pos: false,
      isLoading: false,
      isExporting: false,
      retrievedReceipt: {
        id: null,
        receiptNumber: null
      },
      customer: {
        id: null,
        fullName: null
      },
      receipt: {
        number: "",
        date: moment(new Date()).format('DD-MM-YYYY'),
        dueDate: moment(new Date()).add(15, 'days').format('DD-MM-YYYY'),
        reference: "CUS-22",
        currency: "USD",
        images: {
          logo: "https://public.salesdue.cloud/img/logo_en_original.png",
          background: "https://public.salesdue.cloud/img/watermark-draft.jpg"
        },
        sender: {
          company: undefined,
          address: undefined,
          zip: undefined,
          city: undefined,
          country: undefined,
          email: undefined,
          phone: undefined
        },
        client: {
          name: "",
          address: "",
          zip: "",
          city: "",
          country: "",
          email: "",
          phone: ""
        },
        products: [],
        termsAndConditions: "",
        settings: {
          taxNotation: "vat",
          marginTop: 25,
          marginRight: 25,
          marginLeft: 25,
          marginBottom: 25
        },
        labels: {
          name: "RECEIPT",
          billTo: "To:"
        },
        status: "DRAFT",
        subTotal: 0.00,
        totalTax: 0.00,
        amountPaid: 0.00,
        balance: 0.00,
        total: 0.00
      },
      selectedPaymentMethodId: "CASH",
      paymentMethods: [],
      currencies: ["USD", "ZWL"],
      selectedCurrencyId: "",
      rate: 1.00,
      payment: {
        id: "",
        method: "",
        currency: "",
        amount: 0.00,
        date: undefined,
        reference: 0.00
      },
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 10,
      printReceipt: true,
      orders: [],
      receipts: [],
      logoUrl: undefined,
      showDeleteReceiptButton: process.env.SHOW_DELETE_INVOICE_BUTTON
    }
  },
  watch: {
    'receipt.products': {
      handler(beforeVal, afterVal) {
        this.calculateReceipt()
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    cartTotal() {
      return this.receipt.total
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const day = currentDate.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`
    },
    formatDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm")
    },
    async printTicket() {
      const receipt = this.retrievedReceipt;
      let invoiceId = null;
      if (receipt.items) {
        const invoiceItems = receipt.items.filter(item => item.type === 'INVOICE' || 'ORDER');
        if (invoiceItems) {
          let item = invoiceItems[0];
          invoiceId = item.itemId;
        }
      }

      if (!invoiceId) {
        return;
      }


      let invoice = null;
      await invoiceService.findById(invoiceId)
        .then(response => {
          if (response && response.data) {
            invoice = response.data;
          }
        })
        .catch(e => {
          console.log('Error:', e);
          const error = errorCodes[e.response.status];
          Swal.fire({
            icon: error.icon,
            title: error.title,
            text: e.response.data.narrative || e.response.data.description || 'Failed to process request',
            footer: '<a href="">Why do I have this issue?</a>'
          })
        });

      if (!invoice) {
        return;
      }

      if (this.store.printPosReceipt) {
        let user = JSON.parse(localStorage.getItem('user'));
        const userEmail = user.email
        let items = []
        for (let i = 0; i < invoice.invoiceItems.length; i++) {
          let item = invoice.invoiceItems[i]
          items.push({
            name: item.name,
            qty: item.quantity,
            totalDiscount: item.totalDiscount,
            itemTax: item.totalTax,
            price: item.total
          })
        }
        let tenders = []
        const paymentMethod = receipt.paymentMethod ? receipt.paymentMethod.name : 'CASH'
        tenders.push({
          name: paymentMethod + " (" + receipt.transactionCurrency + ")",
          price: receipt.amountTendered.toFixed(2),
          currency: receipt.transactionCurrency
        })

        let data = {
          "companyName": this.store.name,
          "companyAddress": this.store.address,
          "companyPhone": this.store.phone,
          "registrationNumber": this.store.registrationNumber,
          "vatNumber": this.store.vatNumber,
          "cashierName": receipt.createdBy || userEmail,
          "invoiceNumber": receipt.number,
          "customerNumber": receipt.customerNumber,
          "customerName": receipt.customerName,
          "currency": receipt.transactionCurrency,
          "currencySymbol": getCurrencySymbol(receipt.transactionCurrency),
          "items": items,
          "deductions": [
            {
              "name": "TAX",
              "price": invoice.totalTax
            },
            {
              "name": "DISCOUNT",
              "price": invoice.totalDiscount
            }
          ],
          "tenders": tenders,
          "printerName": localStorage.getItem("RECEIPT_PRINTER_NAME"),
          "templateName": localStorage.getItem("RECEIPT_PRINTER_TEMPLATE"),
          "subTotal": invoice.total,
          "total": invoice.total,
          "amountPaid": receipt.amountPaid,
          "changeCurrency": receipt.transactionCurrency,
          "change": receipt.amountRemaining,
          "paymentsTotal": receipt.amountPaid,
          "date": receipt.date
        }
        // POS printing not needed in customer portal
        // printingService.printTicket(data)
        //   .then(response => {
        //     if (response && response.data && response.data.success === true) {
        //       this.success = true;
        //     } else {
        //       console.error('error', "Failed to print receipt", 5000)
        //       Swal.fire({
        //         icon: 'warning',
        //         title: 'Failed',
        //         text: 'Failed to print receipt',
        //         footer: '<a href="">Why do I have this issue?</a>'
        //       })
        //     }
        //   })
        //   .catch(e => {
        //     console.log('Error:', e);
        //     const error = errorCodes[e.response.status];
        //     Swal.fire({
        //       icon: error ? error.icon : 'warning',
        //       title: error ? error.title : 'Failed',
        //       text: e.response.data ? e.response.data.narrative || e.response.data.description : 'Failed to process request',
        //       footer: '<a href="">Why do I have this issue?</a>'
        //     })
        //   });
        this.success = true; // Customer portal - skip POS printing
      }
      if (this.store.printA4PosReceipt) {
        this.printHtmlTicket()
      }
    },
    retrieveLogo() {
      return new Promise((resolve, reject) => {
        fileService.fetchLogo(localStorage.getItem("mid"))
          .then(response => {
            if (!response) {
              return;
            }
            if (response && response.data.success === true) {
              const contentType = 'image/png';
              const blob = base64StringToBlob(response.data.data.bytes, contentType);
              this.logoUrl = URL.createObjectURL(blob);
              resolve([true, 'Successful', response.data])
              return
            }
            resolve([false, 'Successful', response.data.narrative])
          })
          .catch(e => {
            if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
              return
            }
            reject([false, 'Error occurred', e])
            this.fireNotification('error', "Error occurred", "Failed to retrieve store logo")
          });
      })
    },
    changePaymentCurrency() {
      this.payment.currency = this.selectedCurrencyId
      if (this.retrievedReceipt.currency === this.selectedCurrencyId) {
        let convertedAmount = this.retrievedReceipt.balance
        this.payment.amount = (Math.round(convertedAmount * 100) / 100).toFixed(2);
        return;
      }
      let loader = this.$loading.show({
        container: this.$refs.paymentContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
      currencyService.findCurrencyRate(this.retrievedReceipt.currency, this.payment.currency, localStorage.getItem("mid"),
        this.currentPage, this.recordsPerPage)
        .then(response => {
          if (!response.data.data.length) {
            document.getElementById('showPaymentModal').click()
            Swal.fire({
              icon: 'warning',
              title: '',
              text: "No currency rates defined",
              footer: '<a href="">Why do I have this issue?</a>'
            })
          }
          let rate = response.data.data[0].rate
          localStorage.setItem("rate", JSON.stringify(response.data.data[0]));
          let convertedAmount = this.retrievedReceipt.balance * rate
          this.payment.amount = (Math.round(convertedAmount * 100) / 100).toFixed(2);
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Error occurred", 5000)
        })
        .finally(() => {
          loader.hide()
        })
    },
    convertTo2Dp(amount) {
      if (!amount) {
        amount = 0.00
      }
      return (Math.round(amount * 100) / 100).toFixed(2)
    },
    focusOnPaymentAmount() {
      document.getElementById("payment.amount").focus();
    },
    createReceipt() {
      this.$router.push(`/receipts/create?receiptId=${this.receiptId}`)
    },
    focusOnPaymentInput() {
      // if (this.retrievedReceipt.balance <= 0){
      //   return
      // }
      let existCurrency = this.currencies.find(currency => currency === this.store.currency)
      if (!existCurrency) {
        this.currencies.push(this.store.currency)
      }
      this.retrieveCurrencyRates().then((response) => {
        if (response.success === true) {
          let currencyRates = response.data
          if (currencyRates.length) {
            for (let i = 0; i < currencyRates.length; i++) {
              let currencyRate = currencyRates[i]
              let existCurrency = this.currencies.find(currency => currency === currencyRate.to)
              if (!existCurrency) {
                this.currencies.push(currencyRate.to)
              }
            }
          }
        } else {
          this.fireNotification('warning', response.narrative, 5000)
        }
      })
      document.getElementById('showPaymentModal').click()
      setTimeout(() => {
        document.getElementById('paymentAmount').focus()
        this.payment.currency = this.store.currency
        this.payment.amount = ""
        this.payment.reference = ""
        this.payment.date = this.getCurrentDate()
        this.selectedCurrencyId = this.store.currency
      }, 200);
    },
    retrieveCurrencyRates() {
      // let loader = this.loader(this.$refs.receiptContainer)
      return new Promise((resolve, reject) => {
        currencyService.findCurrencyRates(localStorage.getItem("mid"), this.currentPage, this.recordsPerPage)
          .then(response => {
            resolve(response.data)
          })
          .catch(e => {
            console.log(e);
            if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
              return
            }
            reject(e.response)
          })
          .finally(() => {
            // loader.hide()
          });
      })
    },
    addPayment(e) {
      e.preventDefault();
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.paymentContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      this.payment.amount = document.getElementById('paymentAmount').value
      if (!this.payment.amount || this.payment.amount <= 0) {
        Swal.fire({
          icon: 'warning',
          text: "Amount should be greater than zero",
          footer: '<a href="">Why do I have this issue?</a>'
        })
        loader.hide()
        return
      }
      if (this.payment.amount) {
        let user = JSON.parse(localStorage.getItem('user'));
        let decoded = jwtDecode(user.token);
        let userId = decoded.sub
        let data = {
          paymentMethodId: this.selectedPaymentMethodId,
          paymentMethod: this.paymentMethods.find(paymentMethod => paymentMethod.id === this.selectedPaymentMethodId).description,
          paymentCurrency: this.selectedCurrencyId,
          paymentAmount: this.payment.amount,
          paymentDate: this.payment.date,
          reference: this.payment.reference,
          type: 'INVOICE',
          mid: localStorage.getItem("mid"),
          userId: userId
        };
        receiptService.addPayment(this.retrievedReceipt.id, data)
          .then(response => {
            if (response.data.success && response.data.data) {
              this.retrievedReceipt = response.data.data;
              document.getElementById('edit_personal_details').click();
              Swal.fire({
                icon: 'success',
                text: "Successfully added payment",
                footer: '<a href="">Why do I have this issue?</a>'
              })
            } else {
              Swal.fire({
                icon: 'warning',
                text: response.data.narrative,
                footer: '<a href="">Why do I have this issue?</a>'
              })
            }
          })
          .catch(e => {
            if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
              return
            }
            this.fireNotification('error', "Error occurred", 5000)
          })
          .finally(() => {
            loader.hide()
          })
      }
    },
    getDate(stringDate) {
      const date = moment(stringDate);
      return date.format("DD-MM-YYYY")
    },
    refundReceipt(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'orange',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, refund it!'
      }).then((result) => {
        if (result.isConfirmed) {
          if (id) {
            let loader = this.$loading.show({
              container: this.fullPage ? null : this.$refs.receiptContainer,
              canCancel: false,
              onCancel: this.onCancel,
            });
            return new Promise((resolve, reject) => {
              receiptService.refund(localStorage.getItem('mid'), id)
                .then(response => {
                  if (response.data.code === 'SUCCESS') {
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: "Successfully refunded receipt",
                      footer: '<a href=""></a>'
                    })
                    this.retrievedReceipt = response.data.data
                    return resolve("success")
                  } else {
                    Swal.fire({
                      icon: 'warning',
                      title: 'Failed',
                      text: response.data.narrative || response.data.description,
                      footer: '<a href=""></a>'
                    })
                    return reject(response.data.narrative)
                  }
                })
                .catch(e => {
                  const error = errorCodes[e.response.status];
                  Swal.fire({
                    icon: error.icon,
                    title: error.title,
                    text: e.response.data.narrative || e.response.data.description,
                    footer: '<a href="">Why do I have this issue?</a>'
                  })
                })
                .finally(() => {
                  loader.hide()
                })
            })
          }
        }
      })
    },
    deleteReceipt(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          receiptService.delete(id)
            .then(response => {
              if (response.data.success === true) {
                Swal.fire({
                  icon: 'success',
                  title: 'Deleted',
                  text: "Successfully deleted receipt",
                  footer: '<a href="">Why do I have this issue?</a>'
                })
                this.$router.push('/receipts');
              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Failed',
                  text: response.data.narrative,
                  footer: '<a href="">Why do I have this issue?</a>'
                })
              }
            })
            .catch(e => {
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                return
              }
              Swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: "Can't delete receipt",
                footer: '<a href="">Why do I have this issue?</a>'
              })
            });
        }
      })
    },
    retrieveReceipt(id) {
      this.isLoading = true;
      receiptService.findById(localStorage.getItem('mid'), id)
        .then(response => {
          if (response && response.data.code === 'SUCCESS') {
            this.retrievedReceipt = response.data.data;
            if (this.retrievedReceipt && this.retrievedReceipt.items) {
              this.retrievedReceipt.items.sort((a, b) => Date.parse(b.dateCreated) - Date.parse(a.dateCreated))
            }
            
            // Populate customer details from receipt response
            if (this.retrievedReceipt.customer) {
              this.customer = {
                id: this.retrievedReceipt.customer.customerId || this.retrievedReceipt.customerId,
                fullName: this.retrievedReceipt.customer.name || this.retrievedReceipt.customerName,
                email: this.retrievedReceipt.customer.email,
                phone: this.retrievedReceipt.customer.phone,
                address: this.retrievedReceipt.customer.address
              };
            }
            
            // Fetch store details using businessId from receipt
            if (this.retrievedReceipt.businessId) {
              this.retrieveStore(this.retrievedReceipt.businessId);
            }
            if (!this.retrievedReceipt.items || !this.retrievedReceipt.items.length) {
              const receiptLine = {
                itemId: null,
                itemCode: this.retrievedReceipt.description,
                itemName: this.retrievedReceipt.description,
                quantity: 1,
                amount: this.retrievedReceipt.amountPaid,
                type: 'GENERAL',
                status: 'PENDING',
                subTotal: this.retrievedReceipt.amountPaid,
              }
              this.retrievedReceipt.items.push(receiptLine)
            }
          }
        })
        .catch(e => {
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('error', "Error occurred", "Failed to retrieve receipt")
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    retrieveReceipts(number) {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.receiptContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
      this.isLoading = true
      const params = {
        number: number,
        page: this.currentPage,
        size: this.recordsPerPage,
      }
      receiptService.find(localStorage.getItem("mid"), params)
        .then(response => {
          this.receipts = response.data.data;
          if (this.receipts) {
            this.retrievedReceipt = this.receipts[0];
            this.receiptId = this.receipts[0].id
          }
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('warning', "Oops", "Error occurred")
        })
        .finally(() => {
          this.isLoading = false
          loader.hide()
        });
    },
    retrieveStore(businessId) {
      storeService.findById(localStorage.getItem("mid"), businessId)
        .then(response => {
          if (!response || !response.data) {
            console.log('No store response data');
            return;
          }
          
          // Handle both response.data.data and response.data structures
          this.store = response.data.data || response.data;
          
          if (!this.store || !this.store.name) {
            console.log('Store data missing name:', this.store);
            return;
          }
          
          console.log('Retrieved store:', this.store.name);
          
          // Update receipt.sender for template display
          if (!this.receipt.sender) {
            this.receipt.sender = {};
          }
          this.receipt.sender.company = this.store.name;
          if (this.store.email) this.receipt.sender.email = this.store.email;
          if (this.store.phone) this.receipt.sender.phone = this.store.phone;
          if (this.store.address) this.receipt.sender.address = this.store.address;
          
          // Also update retrievedReceipt.sender
          if (this.retrievedReceipt) {
            if (!this.retrievedReceipt.sender) {
              this.retrievedReceipt.sender = {};
            }
            this.retrievedReceipt.sender.company = this.store.name;
            if (this.store.email) this.retrievedReceipt.sender.email = this.store.email;
            if (this.store.phone) this.retrievedReceipt.sender.phone = this.store.phone;
            if (this.store.address) this.retrievedReceipt.sender.address = this.store.address;
          }
        })
        .catch(e => {
          console.log('Failed to retrieve store details:', e);
        });
    },
    calculateLineTotal(product) {
      return product.price * product.quantity
    },
    calculateReceipt() {
      let total = 0.00
      for (let i = 0; i < this.receipt.products.length; i++) {
        let product = this.receipt.products[i]
        let subTotal = product.price * product.quantity
        product.subTotal = subTotal
        total = total + subTotal
      }
      this.receipt.total = total
    },
    emailReceipt() {
      // Email functionality removed for customer portal
    },
    emailReceiptPdf() {
      localStorage.setItem("viewReceipt", JSON.stringify(this.receipt))
      this.isExporting = true
      const receiptDoc = this.retrievedReceipt
      const router = this.$router;
      const store = this.store;
      const body = document.body.cloneNode(true);
      let element = document.getElementById('printMe');
      element.classList.add('print');
      element.style.border = "none";
      if (this.receipt.termsAndConditions === '') {
        let el = document.getElementById('termsAndConditions')
        if (el) {
          el.style.display = "none";
        }
      }
      if (this.receipt.currency === '') {
        let el = document.getElementById('currency')
        el.style.display = "none";
      }
      $(':input[type="text"]').filter(function (e) {
        if (this.value.length === 0) {
          return true;
        }
      }).hide();
      let opt = {
        margin: 0,
        filename: this.retrievedReceipt.number,
        html2canvas: {
          scale: 2,
          windowWidth: 1024
        },
      }
      html2pdf().from(element).set(opt).toPdf().output('datauristring').then(function (pdfAsString) {
        const arr = pdfAsString.split(',');
        const stringReceipt = arr[1];
        localStorage.setItem("base64Receipt", stringReceipt)
      })
      const base64EmailProps = {
        receiptNumber: receiptDoc.number,
        storeName: store.name,
        to: this.customer.email,
        subject: "Receipt [" + receiptDoc.number + "]"
      }
      localStorage.setItem("base64EmailProps", JSON.stringify(base64EmailProps))
      router.push(`/receipts/${receiptDoc.id}/email?emails=${this.customer.email}&subject=Receipt%20%5B${receiptDoc.number}%5D&receiptNumber=${receiptDoc.number}`)
    },
    formatReceiptFilename(receiptNumber, customerName, issueDate) {
      const safeName = toFilename(customerName);
      const formatDate = (date) => date.toISOString().slice(0, 10).replace(/-/g, '');

      const datePart = issueDate ? formatDate(new Date(issueDate)) : '';
      const receiptPart = receiptNumber ? receiptNumber.replace(/[^a-zA-Z0-9\-]/g, '') : 'RCPT-UNKNOWN';

      return `Receipt_${receiptPart}_${safeName}${datePart ? `_${datePart}` : ''}.pdf`;
    },
    async downloadAsPdf() {
      this.isLoading = true;
      try {
        const fileName = this.formatReceiptFilename(
          this.retrievedReceipt.number,
          this.retrievedReceipt.customerName ? this.retrievedReceipt.customerName : 'Unknown',
          this.retrievedReceipt.date
        );
        await downloadReceiptPdf(
          localStorage.getItem('mid'),
          this.receiptId,
          fileName,
          this.selectedTemplateId,
          (val) => {
            this.isDownloading = val;
          }
        );
      } finally {
        this.isLoading = false;
      }
    },
    exportToPDF() {
      localStorage.setItem("viewReceipt", JSON.stringify(this.receipt))
      this.isExporting = true
      let receiptDoc = this.retrievedReceipt
      const doc = document.body;
      const body = document.body.cloneNode(true);
      let element = document.getElementById('printMe');
      element.classList.add('print');
      element.style.border = "none";
      if (receiptDoc.termsAndConditions === '') {
        let el = document.getElementById('termsAndConditions')
        if (el) {
          el.style.display = "none";
        }
      }
      if (this.receipt.currency === '') {
        let el = document.getElementById('currency')
        el.style.display = "none";
      }
      $(':input[type="text"]').filter(function (e) {
        if (this.value.length === 0) {
          return true;
        }
      }).hide();
      let opt = {
        margin: 0,
        filename: this.retrievedReceipt.number,
        html2canvas: {
          scale: 2,
          windowWidth: 1024
        },
      }
      html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
        this.isExporting = false
        document.body = body;
        window.location.reload()
      }).save();
    },

    exportToPDFF() {
      localStorage.setItem("viewReceipt", JSON.stringify(this.receipt))
      this.isExporting = true
      let receiptDoc = this.receipt
      const body = document.body.cloneNode(true);
      let element = document.getElementById('printMe');
      element.classList.add('print');
      element.style.border = "none";
      if (this.retrievedReceipt.termsAndConditions === '') {
        let el = document.getElementById('termsAndConditions')
        if (el) {
          el.style.display = "none";
        }
      }
      if (this.retrievedReceipt.currency === '') {
        let el = document.getElementById('currency')
        el.style.display = "none";
      }
      $(':input[type="text"]').filter(function (e) {
        if (this.value.length === 0) {
          return true;
        }
      }).hide();
      let opt = {
        margin: 0,
        filename: this.retrievedReceipt.receiptNumber,
        html2canvas: {
          scale: 2,           // higher quality
          windowWidth: 1024   // simulate a browser size that causes the page's responsive CSS to output a pleasing layout in the rendered PDF
        },
        // pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
      }

      // const pages = []
      // pages.push(element)
      // pages.push(element)
      // exportHTMLToPDF(pages).then((doc)=>{
      //   var blobPDF =  new Blob([ doc ], { type : 'application/pdf'});
      //   var blobUrl = URL.createObjectURL(blobPDF);  //<--- THE ERROR APPEARS HERE
      //
      //   window.open(blobUrl);
      // })

      // html2pdf().from(element).set(opt).save().then((doc)=>{
      //
      //   this.isExporting = false
      //   document.body = body;
      //   element.classList.remove('print');
      //   window.location.reload()
      //   this.receipt = receiptDoc
      // })

      html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
        // var pageCount = pdfObj.internal.get();
        // console.log('pageCount', pdfObj.internal.pageSize.height)

        var totalPages = pdf.internal.getNumberOfPages() / 2.4;
        for (var i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
        }
      }).save();

      // pdfObj.deletePage(pageCount)
      // this.isExporting = false
      // document.body = body;
      // pdfObj.autoPrint();
      // window.open(pdfObj.output('bloburl'), '_blank');
      // window.location.reload()


      // html2pdf().from(element).set({
      //   margin:       [1, 0, 0, 0],
      //   filename: 'samplepdf.pdf',
      //   pageBreak: { mode: 'css', before:'#nextpage1'},
      //   jsPDF: {orientation: 'landscape', unit: 'in', format: 'letter'}
      // }).toPdf().get('pdf').then(function (pdf) {
      //   var totalPages = pdf.internal.getNumberOfPages();
      //   for (var i = 1; i <= totalPages; i++) {
      //     pdf.setPage(i);
      //     pdf.setFontSize(10);
      //     pdf.setTextColor(150);
      //   }}).save();

    },
    sendReceiptViaEmail(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#008000',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, send it!'
      }).then((result) => {
        if (result.isConfirmed) {
          let loader = this.$loading.show({
            container: this.fullPage ? null : this.$refs.receiptContainer,
            canCancel: false,
            onCancel: this.onCancel,
          });
          return new Promise((resolve, reject) => {
            receiptService.email(localStorage.getItem('mid'), id)
              .then(response => {
                if (response.data.code === "SUCCESS") {
                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: "Successfully sent receipt via email",
                    footer: '<a href=""></a>'
                  })
                  return resolve("success")
                } else {
                  Swal.fire({
                    icon: 'info',
                    title: 'Failed',
                    text: response.data.narrative,
                    footer: '<a href=""></a>'
                  })
                  return reject(response.data.narrative)
                }
              })
              .catch(e => {
                if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                  return
                }
                return reject("Error occurred whilst sending receipt via email")
              })
              .finally(() => {
                loader.hide()
              })
          })
        }
      })
    },
    payOrderOnline() {
      const currentUrl = window.location.href;
      const returnUrl = encodeURIComponent(currentUrl)
      const url = `${process.env.PAYMENT_GATEWAY_URL}?amount=${this.retrievedReceipt.balance * 100}&currency=${this.retrievedReceipt.currency}&reference=${this.retrievedReceipt.id}&mid=${localStorage.getItem('mid')}&returnUrl=${returnUrl}`
      window.open(url, "_self");
    },
    retrievePaymentMethods() {
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.receiptContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
      const params = {
        page: this.currentPage,
        size: this.recordsPerPage
      }
      paymentMethodService.find(localStorage.getItem("mid"), params)
        .then(response => {
          this.paymentMethods = response.data.data;
          if (this.paymentMethods && this.paymentMethods.length) {
            this.selectedPaymentMethodId = this.paymentMethods[0].id;
          } else {
            this.selectedPaymentMethodId = 'CASH'
          }
        })
        .catch(e => {
          console.log(e);
          if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
            return
          }
          this.fireNotification('warning', "Oops", "Error occurred")
        })
        .finally(() => {
          loader.hide()
        });
    },
    sendReceiptViaEmailFE() {
      localStorage.setItem("viewReceipt", JSON.stringify(this.receipt))
      if (this.customer || this.customer.email) {
        this.isExporting = true
        const receiptDoc = this.retrievedReceipt
        const router = this.$router
        const store = this.store;
        const body = document.body.cloneNode(true);
        let element = document.getElementById('printMe');
        element.classList.add('print');
        element.style.border = "none";
        if (this.receipt.termsAndConditions === '') {
          let el = document.getElementById('termsAndConditions')
          if (el) {
            el.style.display = "none";
          }
        }
        if (this.receipt.currency === '') {
          let el = document.getElementById('currency')
          el.style.display = "none";
        }
        $(':input[type="text"]').filter(function (e) {
          if (this.value.length === 0) {
            return true;
          }
        }).hide();
        let opt = {
          margin: 0,
          filename: this.retrievedReceipt.number,
          html2canvas: {
            scale: 2,           // higher quality
            windowWidth: 1024   // simulate a browser size that causes the page's responsive CSS to output a pleasing layout in the rendered PDF
          },
        }
        html2pdf().from(element).set(opt).toPdf().output('datauristring').then(function (pdfAsString) {
          const arr = pdfAsString.split(',');
          const stringReceipt = arr[1];
          localStorage.setItem("base64Receipt", stringReceipt)
        })
        const base64EmailProps = {
          receiptNumber: receiptDoc.receiptNumber,
          storeName: store.name,
          to: receiptDoc.customer.email,
          subject: "Receipt [" + receiptDoc.receiptNumber + "]"
        }
        localStorage.setItem("base64EmailProps", JSON.stringify(base64EmailProps))
        router.push(`/receipts/${receiptDoc.id}/email`)
      } else {
        Swal.fire({
          icon: 'warning',
          text: 'Customer email is required',
          footer: '<a href="">Need help?</a>'
        })
      }
    },
    receiptStatus(status) {
      if (status === 'Paid') {
        return 'badge-success bg-success-light'
      } else if (status === 'Partially Paid') {
        return 'badge-warning bg-warning-light'
      } else if (status === 'Not Paid') {
        return 'badge-danger bg-danger-light'
      } else {
        return 'badge-secondary bg-secondary-light'
      }
    },
    addReceiptLine() {
      let price = (Math.round(0.00).toFixed(2));
      let receiptLine = {
        sku: "",
        quantity: "1",
        description: "",
        price: price,
        subTotal: 1.00
      }
      this.receipt.products.push(receiptLine)
    },
    deleteItem(product, index) {
      this.receipt.products.splice(index, 1);
    },
    saveRemoteReceipt() {
      this.fireNotification("warning", "", "Sign up to continue", "#", "Sign Up")
    },
    sendReceiptViaWhatsapp() {
      this.fireNotification("warning", "", "Sign up to continue", "#", "Sign Up")
    },
    fireNotification(icon, title, message, footerLink, footerText) {
      Swal.fire({
        icon: 'warning',
        text: message,
        footer: '<a href="">Why am I getting this?</a>'
      })
    },
    approveReceipt(id) {
      if (id) {
        let loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.receiptContainer,
          canCancel: false,
          onCancel: this.onCancel,
        });
        return new Promise((resolve, reject) => {
          receiptService.approve(id)
            .then(response => {
              if (response.data.id) {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: "Successfully updated receipt",
                  footer: '<a href=""></a>'
                })
                this.retrievedReceipt = response.data
                this.viewReceipt(response.data.id)
                return resolve("success")
              } else {
                Swal.fire({
                  icon: 'info',
                  title: 'Failed',
                  text: response.data.narrative,
                  footer: '<a href=""></a>'
                })
                return reject(response.data.narrative)
              }
            })
            .catch(e => {
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                return
              }
              return reject("Error occurred 9")
            })
            .finally(() => {
              loader.hide()
            })
        })
      }
    },
    cloneReceipt(id) {
      if (id) {
        let loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.receiptContainer,
          canCancel: false,
          onCancel: this.onCancel,
        });
        return new Promise((resolve, reject) => {
          receiptService.clone(id)
            .then(response => {
              if (response.data.id) {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: "Successfully clone document",
                  footer: '<a href=""></a>'
                })
                this.retrievedReceipt = response.data
                this.$router.push(`/receipts/${response.data.id}`)
                return resolve("success")
              } else {
                Swal.fire({
                  icon: 'info',
                  title: 'Failed',
                  text: response.data.narrative,
                  footer: '<a href=""></a>'
                })
                return reject(response.data.narrative)
              }
            })
            .catch(e => {
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                return
              }
              return reject("Error occurred 9")
            })
            .finally(() => {
              loader.hide()
            })
        })
      }
    },
    cancelReceipt(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          if (id) {
            let loader = this.$loading.show({
              container: this.fullPage ? null : this.$refs.receiptContainer,
              canCancel: false,
              onCancel: this.onCancel,
            });
            return new Promise((resolve, reject) => {
              receiptService.cancel(id)
                .then(response => {
                  if (response.data.id) {
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: "Successfully cancelled receipt",
                      footer: '<a href=""></a>'
                    })
                    this.retrievedReceipt = response.data
                    this.$router.push("/receipts")
                    return resolve("success")
                  } else {
                    Swal.fire({
                      icon: 'info',
                      title: 'Failed',
                      text: response.data.narrative,
                      footer: '<a href=""></a>'
                    })
                    return reject(response.data.narrative)
                  }
                })
                .catch(e => {
                  if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                    return
                  }
                  return reject("Error occurred 9")
                })
                .finally(() => {
                  loader.hide()
                })
            })
          }
        }
      })
    },
    viewReceiptPayments() {
      this.$router.push(`/receipts/${this.receiptId}/payments`);
    },
    editReceipt(id) {
      this.$router.push(`/receipts/${id}/edit`);
    },
    isValidGUID(str) {
      let regex = new RegExp(/^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/);
      if (str == null) {
        return false;
      }
      if (regex.test(str) === true) {
        return true;
      } else {
        return false;
      }
    }
  },
  async mounted() {
    if (!this.currentUser) {
      await this.$router.push('/login')
      return
    }
    
    this.isLoading = true;
    this.receiptId = this.$route.params.id;
    if (!this.isValidGUID(this.receiptId)) {
      this.retrieveReceipts(this.receiptId)
    } else {
      this.retrieveReceipt(this.receiptId);
    }
    
    this.payment.date = this.getCurrentDate()
  }
}
</script>

<style>
button:disabled {
  cursor: not-allowed
}

.white-space {
  width: 200px;
}

.pre-line {
  white-space: pre-line;
}

.w99 {
  width: 100%;
  border: none white;
}

.w101 {
  width: 100%;
  height: 35px;
  border: none white;
}

.printBoarder {
  border: 1px solid lightgray;
  border-radius: 5px;
}


.tblItems thead tr th {
  padding: 0.50rem !important;
}

.tblItems tbody tr td {
  padding: 0.30rem !important;
}


.tblTotals tbody tr td {
  padding: 0.30rem !important;
}

.tblTotals tr.borderless td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0);
}

.tblTotals tbody tr {
  border-bottom: 0 solid rgba(0, 0, 0, 0.0);
}

tr.noBorder td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0.05);
  background-color: #f5f5f5;
}


.tblPayments tr.borderless td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0);
}

.tblPayments tbody tr td {
  padding: 0.50rem !important;
}

.tblPayments tbody tr {
  border-bottom: 0 solid rgba(0, 0, 0, 0.0);
}


.tblReceiptHeaderDetails tr.borderless td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0);
}

.tblReceiptHeaderDetails tbody tr td {
  padding: 0.20rem !important;
}

.tblReceiptHeaderDetails tbody tr {
  border-bottom: 0 solid rgba(0, 0, 0, 0.0);
}

@media print {
  .hidden-print,
  .hidden-print * {
    display: none !important;
  }

  #items-header {
    background-color: black;
    color: white;
  }

  .no-print {
    display: none !important;
  }

  .result {
    height: 100%;
    overflow: visible;
  }

  .printBoarder {
    border: none !important;
    border-radius: 0 !important;
  }
}

@media only screen and (max-width: 900px) {

  .quote-header {
    display: none;
  }

  #printMe {
    width: 100%;
    height: 100%;
  }

  .receipt-wrapper {
    margin-top: 16px;
    margin-left: 0;
    margin-right: 0
  }
}

.print {
}
</style>



// WEBPACK FOOTER //
// src/components/receipts/ViewReceipt.vue